<div>

</div>
<h3 class="sectionTitle">{{'FRONT_USER.WORKSPACE.MY_MESSAGES'| translate}}</h3>
<app-grid-view #MyMessages></app-grid-view>
